<div class="speed-violation"
  [class.usa-or-can]="country === ECountry.USA || country === ECountry.CAN">
  <div *ngIf="speedType === ESpeedType.PostedSpeed && (speedLimitType === ESpeedLimitTypes.postedSpeed || speedLimitType === ESpeedLimitTypes.postedAndRoad)"
    class="speed-violation__text"
    i18n="@@S_POSTED_SPEED_TYPE_1">Posted Speed</div>
  <div class="speed-violation__text"
    *ngIf="speedType === ESpeedType.RoadSpeed && (speedLimitType === ESpeedLimitTypes.roadSpeed || speedLimitType === ESpeedLimitTypes.postedAndRoad)"
    i18n="@@S_POSTED_SPEED_TYPE_2">Road Speed</div>
  <div class="speed-violation__value">{{ speed }}</div>
</div>
